import React from "react";
import UnitCountFive from "./child/UnitCountFive";
import TrafficSourcesOne from "./child/TrafficSourcesOne";
import TopCategoriesOne from "./child/TopCategoriesOne";
import TopInstructorsOne from "./child/TopInstructorsOne";
import StudentProgressOne from "./child/StudentProgressOne";
import CoursesOne from "./child/CoursesOne";
import CourseActivityOne from "./child/CourseActivityOne";
import TotalSubscriberOne from "./child/TotalSubscriberOne";
import StudentProgressStats from "./child/StudentProgressStats";
import CategoryProgressStats from "./child/CategoryProgressStats";
import StudentDetailedStats from "./child/StudentDetailedStats";
import SubscriptionRateChart from "./child/SubscriptionRateChart";
import SubscriptionPlanDistributionChart from "./child/SubscriptionPlanDistributionChart";
import RevenueStatsChart from "./child/RevenueStatsChart";
import ExamQuarterlyDistributionChart from "./child/ExamQuarterlyDistributionChart";
import TestimonialManager from "./child/TestimonialManager";

// Import circular progress CSS
import "../assets/css/progress-circular.css";

const DashBoardLayerSix = () => {
  return (
    <>
      <div className="row gy-4 mb-24">
        {/* UnitCountFive */}
        <UnitCountFive />

        {/* TotalSubscriberOne */}
        <TotalSubscriberOne />

        {/* RevenueStatsChart - Revenue Statistics */}
        <RevenueStatsChart />

        {/* Subscription Rate Chart */}
        <SubscriptionRateChart />

        {/* Exam Quarterly Distribution Chart */}
        <ExamQuarterlyDistributionChart />

        {/* Subscription Plan Distribution Chart */}
        <SubscriptionPlanDistributionChart />

        {/* TestimonialManager - Manage Website Testimonials */}
        <TestimonialManager />

        {/* TopCategoriesOne */}
        <TopCategoriesOne />

        {/* TopInstructorsOne */}
        <TopInstructorsOne />

        {/* StudentProgressOne */}
        <StudentProgressOne />

        {/* StudentProgressStats */}
        <StudentProgressStats />

        {/* CategoryProgressStats */}
        <CategoryProgressStats />

        {/* StudentDetailedStats - Detailed student view */}
        <StudentDetailedStats />

        {/* CoursesOne */}
        <CoursesOne />

        {/* CourseActivityOne */}
        <CourseActivityOne />

        {/* TrafficSourcesOne */}
        <TrafficSourcesOne />
      </div>
    </>
  );
};

export default DashBoardLayerSix;
